import { isTextNoteNode } from '@/components/diagrams/FlowChart/utils/textNoteUtils';

import { EntityDiagramActionFn, UpdateTextNoteAction } from '../types';

export const updateTextNoteAction: EntityDiagramActionFn<
  UpdateTextNoteAction
> = (state, action) => {
  return {
    ...state,
    nodes: state.nodes.map((node) => {
      if (!isTextNoteNode(node) || node.id !== action.nodeId) return node;
      // Clear height so the wrapper auto-sizes to the new content —
      // intentionally overrides any prior manual resize.
      return {
        ...node,
        height: undefined,
        measured: { ...node.measured, height: undefined },
        data: {
          ...node.data,
          notes: action.notes,
        },
      };
    }),
  };
};
